<template>
    <Dialog :visible.sync="isExibirPDF" :contentStyle="dimensaoTela()" :position="position" maximizable
        :header="tituloTela" :modal="modal" class="pdf-seplag"  >

        <div id="no-print" v-if="blockPrint">
            <p>Válido somente no formato digital.Impressão desta página não é permitida.</p>
        </div>
         <embed style="width: 100%; height: 100%" :src="stringPDF+'#toolbar=0&navpanes=0&scrollbar=0&zoom=170'" v-if="alteraToolbar">
          <embed style="width: 100%; height: 100%" :src="stringPDF" v-if="!alteraToolbar">
        
    </Dialog>
</template>

<script>
import download from 'downloadjs';
export default {
    name: "ExibirPDF",
    model: {
        prop: 'exibirPDF',
        event: 'change'
    },
    props: {
        exibirPDF: {
            // Propriedade utilizada para exibir a tela do diálogo do cadastro rápido
            type: Boolean,
            default: true
        },  
        tituloTela: {
            // Título a ser exibido na tela de cadastro rápido
            type: String
        },
        nomeDocumento: {
            // Título a ser exibido na tela de cadastro rápido
            type: String,
            default: "Documento"
        },
        position:{
            // "center", "top", "bottom", "left", "right", "topleft", "topright", "bottomleft" or "bottomright"
            type: String,
            default: "center"
        },
        tamanhoTela: {
            // Tamanho do width a ser dimensionado na tela do cadastro rápido
            type: String
        },
        alturaTela: {
            // Tamanho do width a ser dimensionado na tela do cadastro rápido
            type: String
        },
        visivelFechar: {
            // Informa se tela do cadastro rápido deve ser exibido no modo modal, default=true
            type: Boolean,
            default: true
        },
        modal: {
            // Informa se tela do cadastro rápido deve ser exibido no modo modal, default=true
            type: Boolean, 
            default: true             
        },
        pdfElement:{
          type: String,
          required: true
        },

        blockPrint:{
             type: Boolean, 
            default: false 
        },
        alteraToolbar:{
             type: Boolean, 
            default: false 
        }
    },
    methods:{              
        dimensaoTela(){    
            let tela = ""            
            if(this.tamanhoTela && this.tamanhoTela.indexOf('.')> 0){
                let css = this.tamanhoTela.split('.')                
                 tela = tela + `width: ${css[0]}${css[1]};`
            }else if(this.tamanhoTela){
                tela = tela + `width: ${this.tamanhoTela}px;`                     
            }           
            if(this.alturaTela  && this.alturaTela.indexOf('.')> 0){
                let css = this.alturaTela.split('.')  
                tela = tela + `height: ${css[0]}${css[1]};`                 
            }else if(this.alturaTela){
                tela = tela + `height: ${this.alturaTela}px;`                     
            } 
            return tela
        },
        fecharTela(){
            this.isExibirPDF = !this.isExibirPDF
        }
    },
    computed: {
        isExibirPDF: {
            get(){
                if(window.innerWidth < 1024){
                    download(`data:application/pdf;base64,${this.pdfElement}`, `${this.nomeDocumento}`, "application/pdf");
                    return false
                }else{
                    return this.exibirPDF
                }
            },
            set(){
                // Emite uo evento personalizado para que seja modificado na origem
                this.$emit('change', !this.exibirPDF)
            }
        },
        stringPDF: {
            get(){
                return "data:application/pdf;base64," + this.pdfElement
            }
        }
    },
   /* mounted(){
       document.addEventListener('keydown', function (event) {

      if (event.pr) {
        if (event.key === 'l') {
          //setLoginSeplagAtivo(true)
          console.log("teste 1")
        } else {
          console.log("teste 2")
        }
      }
    });
    }*/
   
}
</script>

<style>
@media screen and (max-width: 40em) {
    .pdf-seplag {
        width: 95% !important;
    }
    
}

.p-dialog-maximized .p-dialog-content{
    width: 100% !important;
    height: 100% !important;
}
#no-print {
     display: none;
}

@media print {
  /* body {
    display: none;
  } */
  #no-print {
    display: block !important;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    text-align: center;
    z-index: 9999;
  }
}
</style>